import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ClientImportConfig, CustomersTanksImportResponse, CustomersTanksSaveRequest, EmployeesImportResponse, EmployeesSaveRequest } from "src/app/models/import/import.model";


@Injectable({ providedIn: 'root' })
export class ImportService {

    public config$ = new BehaviorSubject<ClientImportConfig | null>(null);
    
    constructor(private http: HttpClient) { }

    loadConfig(distId: number): void {
        this.getImportConfig(distId).subscribe(cfg => {
            this.config$.next(cfg);
        });
    }

    upload(
        type: 'employees' | 'customers-tanks' | 'client-customers-tanks',
        file: File,
        distributorId?: number
    ): Observable<EmployeesImportResponse | CustomersTanksImportResponse> {

        const formData = new FormData();
        formData.append('file', file);

        switch (type) {

            case 'employees':
                return this.http.post<EmployeesImportResponse>(
                    `/api/employee/import`,
                    formData
                );

            case 'customers-tanks':
            case 'client-customers-tanks':
                formData.append('distributorId', distributorId!.toString());
                return this.http.post<CustomersTanksImportResponse>(
                    `/api/customer/import`,
                    formData
                );
        }
    }


    getImportConfig(distId: number): Observable<ClientImportConfig> {
        return this.http.get<ClientImportConfig>(`/api/customer/config?distId=${distId}`);
    }


    getEmployeeRoles() {
        return this.http.get<string[]>('/api/employee/roles');
    }

    saveEmployees(request: EmployeesSaveRequest): Observable<any> {
        return this.http.post('/api/employee/saveEmployeeImport', request);
    }

    saveCustomersAndTanks(request: CustomersTanksSaveRequest): Observable<any> {
        return this.http.post(`/api/customer/saveCustomerTankImport`, request);
    }

}
